import { FOCUSED_COLOR, getTrendColor, MY_COMPANY_COLOR } from '../../../../utils/chart';

export const mapPropsToDto = ({ data, radius, borderWidth, dataKeys, getColor, theme, reverseTrendGroup }) => {
  const isMultipleValues = dataKeys?.length === 2;

  const getValueColor = (domainEntree, keyIndex) => {
    const score = domainEntree[dataKeys?.[keyIndex]]?.score;
    const trend = domainEntree[dataKeys?.[keyIndex]]?.trend;

    return getColor
      ? getColor({ trend, score, theme, isReversed: reverseTrendGroup })
      : getTrendColor({ trend, score, theme, isReversed: reverseTrendGroup });
  };

  const getScore = (domainEntree, keyIndex) => {
    return domainEntree[dataKeys?.[keyIndex]]?.score;
  };

  const getTrend = (domainEntree, keyIndex) => {
    return domainEntree[dataKeys?.[keyIndex]]?.trend;
  };

  return data.map((domainEntree) => ({
    label: domainEntree.label || domainEntree.domain,
    labelColor: domainEntree.myCompany ? MY_COMPANY_COLOR : domainEntree.inFocus ? FOCUSED_COLOR : undefined,
    backgroundColor: getValueColor(domainEntree, 0),
    borderWidth: isMultipleValues ? borderWidth : 0,
    borderColor: isMultipleValues ? getValueColor(domainEntree, 1) : undefined,
    radius: domainEntree.inFocus ? radius * 1.5 : radius,
    x: getScore(domainEntree, 0),
    y: isMultipleValues ? getScore(domainEntree, 1) : getTrend(domainEntree, 0),
    xTrend: isMultipleValues ? getTrend(domainEntree, 0) : undefined,
    yTrend: isMultipleValues ? getTrend(domainEntree, 1) : undefined,
    domain: domainEntree.domain,
    companyName: domainEntree.companyName,
  }));
};
